import * as Style from './ToastProvider.css';

const ToastProvider = () => {
  return <Style.Toast autoClose={5200} hideProgressBar />;
};

export default ToastProvider;
